import React, { useState, useEffect } from 'react';
import { Grid, TextField, Button, FormControl, InputLabel, Select, MenuItem, CircularProgress, OutlinedInput } from '@mui/material';
import { Search as SearchIcon, CleaningServices as CleaningServicesIcon, Add as AddIcon } from '@mui/icons-material';


function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);
    return debouncedValue;
}

export default function FiltrosBuscaDeGrupos({ onSearch, onClear, oncreate }) {
    const [filtros, setFiltros] = useState({
        nome: '',
        status: '',
        cod_grupo: '',
    });


    const debouncedFiltros = useDebounce(filtros, 500);

    useEffect(() => {
        // Dispara a busca apenas se o usuário preencheu algo
        const isFiltroPreenchido = Object.values(debouncedFiltros).some(v => v !== '' && v !== 0);
        if (isFiltroPreenchido) {
            onSearch(debouncedFiltros);
        }
    }, [debouncedFiltros, onSearch]);

    const handleChange = (e) => {
        setFiltros(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleClearClick = () => {
        setFiltros({
            nome: '',
            status: '',
            cod_grupo: '',
        });
        onClear();
    };

    return (
        <Grid container spacing={2} alignItems="center">
            <Grid item
                size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}
            >
                <TextField
                    fullWidth
                    name="nome"
                    value={filtros.nome}
                    onChange={handleChange}
                    label='Nome do produto'
                    variant="outlined"
                    InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                    InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                />
            </Grid>

            <Grid item
                size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}
            >
                <TextField
                    type='number'
                    fullWidth
                    name="cod_grupo"
                    value={filtros.cod_grupo}
                    onChange={handleChange}
                    label='Código do grupo'
                    variant="outlined"
                    InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                    InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                />
            </Grid>

            <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                <TextField
                    select
                    fullWidth
                    label="Ativo"
                    name="status"
                    value={filtros.status === '' ? 'S' : filtros.status}
                    onChange={handleChange}
                    variant="outlined"
                    InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                    InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                >
                    <MenuItem value="S">Sim</MenuItem>
                    <MenuItem value="N">Não</MenuItem>
                </TextField>
            </Grid>

            <Grid container spacing={1} size={{ sx: 12, sm: 12, md: 12, lg: 12, xl: 12, xs: 12 }} justifyContent="flex-end">
                <Grid item>
                    <Button variant="outlined" onClick={handleClearClick} title="Limpar filtros">
                        <CleaningServicesIcon />
                    </Button>
                </Grid>
                <Grid item >
                    <Button onClick={() => { oncreate() }} title="Adicionar" variant="outlined" ><AddIcon /></Button>
                </Grid>
            </Grid>
        </Grid>
    );
}